
import { Component, Vue, Emit, Watch, Prop } from "vue-property-decorator";
import rest from "@/rest";
// components
import ExpandableCard from "../Shared/ExpandableCard.vue";
import TusFileDrop from "@/components/Shared/TusFileDrop.vue";
import { signalrEventBus } from "@/main";
// interfaces
import {
  CourseElementTypeItem,
  courseElementTypeItems,
} from "@/interfaces/Types";
import { namespace } from "vuex-class";
import { ParamDictionary } from "@/interfaces/ParamDictionary";
import { ExerciseVM } from "@/interfaces/ExerciseVM";
import { CourseElementVm } from "@/interfaces/CourseElementVm";
import { FileDetailsVm } from "@/interfaces/FileDetailsVm";
import { ExBundleVM } from "@/interfaces/ExBundleAssignmentGroupVM";
import { vuex } from "@/store";

const globals = namespace("globals");

@Component({
  components: {
    ExpandableCard,
    TusFileDrop,
  },
})
export default class ScormElement extends Vue {
  @Prop() element!: CourseElementVm;

  @globals.Getter selectedBundle!: ExBundleVM | null;
  @globals.Getter selectedExercise!: ExerciseVM | null;

  isBusy = false;
  guid = "";

  mounted() {}
  created() {
    // SignalR event listener
    signalrEventBus.$on('zipArchiveCreationFinished', this.zipArchiveCreationFinished);
    signalrEventBus.$on('backgroundTaskEvent', this.backgroundTaskEvent);
  }

  beforeDestroy() {
    // clearAllBodyScrollLocks();
    // Make sure to cleanup SignalR event handlers when removing the component
    signalrEventBus.$off('zipArchiveCreationFinished', this.zipArchiveCreationFinished);
    signalrEventBus.$off('backgroundTaskEvent', this.backgroundTaskEvent);
  }

  // SignalR events
  zipArchiveCreationFinished(response: any) {
    console.log("ScormElement > Zip archive creation finished:", response);
    // Will be handled in parent component
    // if (response.status == "SUC") {
    //   this.$globalHelper.downloadFile(response.zipFilePath);
    // } else {
    // }

    // this.$emit('content:ZipArchiveCreationFinished');
    this.isBusy = false;
  }

  async backgroundTaskEvent(response: { id: string, progress: number, message: string, status: string }) {
    if (this.guid !== response.id) return;
    console.log("ScormElement > Background task event:", response);
    if (response.status == "INF") {
      vuex.ux.SB_SUCCESS({
        message: response.message,
        timeout: 1500
      });
      return;
    }

    // this.isBusy = false;
  }

  onNewFileDropped(fileDetails: FileDetailsVm) {
    if (fileDetails.fileType != "Zip") {
      this.$store.commit("ux/SB_FAILURE", {
        message: "Bei dieser Datei handelt es sich nicht um ein Zip Archiv.",
        timeout: 0,
      });
      return;
    }
    this.element.contentUrl = fileDetails.filePath;
  }

  async onMediaFileUploaded(response: any): Promise<void> {
    if (!this.selectedExercise) return;
    if (!response.success) {
      this.$store.commit("ux/SB_FAILURE", {
        message: response.message,
        timeout: 0,
      });
      return;
    }

    let params: ParamDictionary = { dictionary: {} };
    params.dictionary!["BundleId"] = this.selectedExercise.exBundleId!.toString();
    params.dictionary!["ExerciseId"] = this.selectedExercise.id!.toString();
    params.dictionary!["UpdateBundle"] = "false"; // Ignore bundle.xlsx because it does not exist in this case
    params.dictionary!["OnlyScormZip"] = "true"; // Only SCORM zip files should be accepted
    params.dictionary!["FileName"] = response.fileName!;
    params.dictionary!["LocalPath"] = ""; // not used in this case
    await rest
      .url("contentManager/moveFileToLocalDir")
      .post(params)
      .then(async (response) => {
        if (!response) {
          return;
        }
        this.element.title = response;
        this.$emit('updated:ScormElement', this.element);
      })
      .catch((err) => {})
      .finally(() => {
        this.isBusy = false;
      });
  }

  async createScormZipFile() {
    this.isBusy = true;

    await this.$l3rnOnlineHub.ensureConnection();

    let params: ParamDictionary = { dictionary: {}};
    params.dictionary!["SignalRId"] = this.$l3rnOnlineHub.ConnectionId!;
    params.dictionary!["BundleId"] =  this.selectedBundle!.id.toString();
    params.dictionary!["DirName"] = this.selectedExercise?.scormSettings?.directoryName ?? "";

    await rest.url("contentManager/createScormZipFile")
      .post(params)
      .then((guid) => {
        this.guid = guid;
      });
      // .finally(() => {
      //   this.scormZipCreationBusy = false;
      // });
  }
}
